import { AdminService } from "../admin.service";
import { FetchListAvatarsResModel } from "@/services/student/model";
export interface StudentRequestModel {
  sessionId: string;
  studentId: string;
}
class GLStudentService extends AdminService {
  getAvatarStudent(studentId: string): Promise<any> {
    return this.get("students/avatars", { studentIds: studentId });
  }
  fetchListAvatars(listIds: string[]): Promise<FetchListAvatarsResModel> {
    let studentId = "";
    listIds.map((id: string, index: number) => {
      if (index != 0) {
        studentId += "&";
      }
      studentId += "studentIds=" + id;
    });
    return this.get(`students/avatars?${studentId}&`);
  }
}

export const StudentService = new GLStudentService();
